import React from 'react';
import {withRouter} from "react-router";
import APPCONFIG from 'constants/Config';
import TextField from '@material-ui/core/TextField';
import {Button} from "reactstrap";
import {Link} from "react-router-dom";
import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import API from "@beardeddevops/react.api";
import {toast} from "react-toastify";
import {Card, CardContent} from "@material-ui/core";

class Information extends Framework.Components.Object {

	constructor(props) {
		super(props, Types.Accounts._name);
		this.model.requestType = 'GET';
		this.brand = APPCONFIG.brand;
		this.shouldAutoLoad = false;
	}

	render() {
		return (
			<div className="pos-container">
				<div className="pos-header">
					<div className="pos-back-button-wrapper">
						<Link to={"/login"} className="pos-back-button">
							Back to Homepage
						</Link>
					</div>
					<h1 className="pos-main-title">
						Find out about the new Point of Sale Today
					</h1>
				</div>

				<div className="pos-feature">
					<div className="pos-feature-content">
						<h2 className="pos-feature-title">FFL Boss Integration</h2>
						<p className="pos-feature-description">
							Point of Sale is able to directly integrate with FFL Boss allowing you to
							maintain a single firearms list between the two products.
						</p>
					</div>
					<div className="pos-feature-image">
						<img
							src="/assets/images/bpos-products.png"
							alt="FFL Boss Integration"
						/>
					</div>
				</div>

				<hr className="pos-divider" />

				<div className="pos-feature">
					<div className="pos-feature-content">
						<h2 className="pos-feature-title">Z11 With Chip Integration</h2>
						<p className="pos-feature-description">
							Compatible with Dejavoo Z11 counter top touch screen card terminal. The Z11
							supports WiFi connectivity and has EMV and NFC Contactless built in.
						</p>
					</div>
					<div className="pos-feature-image">
						<img
							src="/assets/images/dejavoo-z11.jpg"
							alt="Z11 Support"
						/>
					</div>
				</div>

				<hr className="pos-divider" />

				<div className="pos-logos-section">
					<div className="pos-feature-content">
						<h2 className="pos-feature-title">Multi-Network Credit Card Processing</h2>
						<p className="pos-feature-description">
							Point of Sale seamlessly integrates with five major payment processing networks: Fortis, TransNational, Fluidpay, TacticalPay, and AltruPay. This multi-network support ensures reliable transaction processing and gives you the freedom to choose the payment processor that best fits your needs and fee structure.
						</p>
					</div>
					<div className="pos-logos-grid">
						<div className="pos-logo-item">
							<img
								src="/assets/images/fortis-logo.png"
								alt="Fortis"
							/>
						</div>
						<div className="pos-logo-item">
							<img
								src="/assets/images/trans-national.png"
								alt="Trans National"
							/>
						</div>
						<div className="pos-logo-item">
							<img
								src="/assets/images/fluid-pay.svg"
								alt="Fluid Pay"
							/>
						</div>
						<div className="pos-logo-item">
							<img
								src="/assets/images/tacticalpay-logo.jpg"
								alt="Tactical Pay"
							/>
						</div>
						<div className="pos-logo-item">
							<img
								src="/assets/images/altrupay-logo.jpg"
								alt="Altru Pay"
							/>
						</div>
					</div>
				</div>

				<hr className="pos-divider"/>

				<div className="pos-feature">
					<div className="pos-feature-content">
						<h2 className="pos-feature-title">Fast and Easy Checkout</h2>
						<p className="pos-feature-description">
							With our fast checkout process it is a breeze to run automatic, manual, check,
							and cash transactions.
						</p>
					</div>
					<div className="pos-feature-image">
						<img
							src="/assets/images/new-checkout.png"
							alt="Checkout Process"
						/>
					</div>
				</div>
			</div>
		)
	}
}

const Informational = withRouter(Information);
const Page = () => (
	<div className="page-informational" style={{ background: "white" }}>
		<div className="main-body">
			<div key="1">
				<Informational/>
			</div>
		</div>
	</div>
);

export default Page;
